import React from "react"
import {Box, Chip, Typography} from "@mui/material"
import AttachFileIcon from "@mui/icons-material/AttachFile"

import type {UnidentifiedAttachment} from "../types"

function formatAttachmentSize(sizeBytes: number): string {
	if (sizeBytes < 1024) return `${sizeBytes} B`
	if (sizeBytes < 1024 * 1024) return `${Math.round(sizeBytes / 1024)} KB`
	return `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`
}

// Metadata only: no download route serves an attachment without a customer, so
// the chips stay unclickable rather than offering a link that cannot be served.
function AttachmentChips({attachments}: {attachments: UnidentifiedAttachment[] | null}) {
	if (!attachments?.length) return null

	return (
		<Box mt={1} display="flex" flexWrap="wrap" gap={1}>
			{attachments.map((attachment) => (
				<Box key={attachment.Index} display="flex" alignItems="center" gap={0.5}>
					<Chip
						label={attachment.Filename}
						title={attachment.Filename}
						size="small"
						icon={<AttachFileIcon />}
					/>
					<Typography variant="caption" color="textSecondary">
						{formatAttachmentSize(attachment.SizeBytes)}
					</Typography>
				</Box>
			))}
		</Box>
	)
}

export {AttachmentChips, formatAttachmentSize}
